import { render, staticRenderFns } from "./fakultekurulu.vue?vue&type=template&id=88dff204&"
import script from "./fakultekurulu.vue?vue&type=script&lang=js&"
export * from "./fakultekurulu.vue?vue&type=script&lang=js&"
import style0 from "./fakultekurulu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports